import { Languages, WifiOff, Wifi } from "lucide-react";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import { Switch } from "@/components/ui/switch";
import { useLang } from "@/context/LanguageContext";
import { CLASS_LANGS, useClassLang, useClassPrefs } from "@/lib/smart";

export const LangPicker = ({ testid = "class-lang-select", compact = false }) => {
  const { L } = useLang();
  const lang = useClassLang();
  const setLang = useClassPrefs((s) => s.setLang);
  return (
    <Select value={lang} onValueChange={setLang}>
      <SelectTrigger data-testid={testid} aria-label={L("Class language", "क्लास की भाषा")}
        className={`rounded-full bg-white border-slate-300 text-[#0A192F] font-semibold ${compact ? "h-10 w-full sm:w-52" : "h-11 w-full sm:w-60"}`}>
        <Languages className="w-4 h-4 mr-1 text-[#FF2E63] shrink-0" /><SelectValue />
      </SelectTrigger>
      <SelectContent className="bg-white">
        {CLASS_LANGS.map(([code, native, en, note]) => (
          <SelectItem key={code} value={code} data-testid={`${testid}-option-${code}`}>
            {native}{native !== en ? ` · ${en}` : ""}{note ? ` (${note})` : ""}
          </SelectItem>
        ))}
      </SelectContent>
    </Select>
  );
};

export const LowDataToggle = () => {
  const { L } = useLang();
  const { lowbw, setLowbw } = useClassPrefs();
  return (
    <label className="inline-flex items-center gap-2 h-11 px-4 rounded-full bg-white border border-slate-300 text-sm font-semibold cursor-pointer select-none" data-testid="lowbw-toggle-label">
      {lowbw ? <WifiOff className="w-4 h-4 text-[#B45309]" /> : <Wifi className="w-4 h-4 text-[#007A8A]" />}
      {L("Low data mode", "कम डेटा मोड")}
      <Switch checked={lowbw} onCheckedChange={setLowbw} data-testid="lowbw-toggle" />
    </label>
  );
};
